import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'green-plus-button',
    templateUrl: './green-plus-button.component.html',
    styleUrls: ['./green-plus-button.component.scss'],
    standalone: false
})
export class GreenPlusButtonComponent implements OnInit {
  
  @Output() press = new EventEmitter();

  constructor() { }
  
  onPress() {
    this.press.emit();
  }
  
  ngOnInit(): void {
  }

}
